var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('counter',{attrs:{"disabled":_vm.isReadOnly,"color":_vm.state,"initial-count":_vm.currentValue},on:{"count":function($event){return _vm.beforeUpdateField(_vm.field, $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }